// Typewriter effect: type one word at a time, then backspace, then next word
const typewriterElement = document.querySelector(".gsap-typewriter")
const INITIAL_DELAY = 1500
if (typewriterElement) {
	const wordElements = typewriterElement.querySelectorAll(".typewriter-word")
	const words = Array.from(wordElements).map(el => el.textContent)

	// Use the first word span as the typing container (already visible in DOM)
	const typingContainer = wordElements[0]

	// Hide all other word spans
	wordElements.forEach((el, i) => {
		if (i > 0) el.style.display = "none"
	})

	let currentWordIndex = 0
	let isTyping = false // Start by backspacing the first word
	let currentCharIndex = words[0].length

	function typeNextChar() {
		if (currentWordIndex >= words.length) {
			currentWordIndex = 0 // Loop back to first word
		}

		const currentWord = words[currentWordIndex]

		if (isTyping) {
			// Typing forward
			if (currentCharIndex < currentWord.length) {
				typingContainer.textContent = currentWord.substring(0, currentCharIndex + 1)
				currentCharIndex++
				setTimeout(typeNextChar, 100) // Typing speed
			} else {
				// Finished typing, wait then start backspacing
				isTyping = false
				setTimeout(typeNextChar, 1500) // Pause before backspacing
			}
		} else {
			// Backspacing
			if (currentCharIndex > 0) {
				currentCharIndex--
				typingContainer.textContent = currentWord.substring(0, currentCharIndex)
				setTimeout(typeNextChar, 50) // Backspace speed (faster)
			} else {
				// Finished backspacing, move to next word
				isTyping = true
				currentWordIndex++
				setTimeout(typeNextChar, 300) // Pause before next word
			}
		}
	}
	window.setTimeout(() => { // delay for CLS performance
	// Start the typewriter effect (delay before backspacing first word)
		setTimeout(typeNextChar, 1500)
	}, INITIAL_DELAY)
}
